<template>
  <gg-card>
    <gg-card-header>
      Manage Autoupdate Settings
    </gg-card-header>
    <gg-card-text>
      <v-form :disabled="loading">
        <v-radio-group
          v-model="auto_upgrade_core"
          v-validate="'required'"
          name="Option"
          :error-messages="errors.collect('Option')"
          :disabled="loadingInstallations"
        >
          <v-radio label="Do not upgrade" :value="0" />
          <v-radio label="Upgrade to minor version only" :value="1" />
          <v-radio label="Upgrade to any latest version available" :value="2" />
        </v-radio-group>
        <v-checkbox
          v-model="auto_upgrade_plugins"
          label="Auto Upgrade Plugins"
          :disabled="loadingInstallations"
          :true-value="1"
          :false-value="0"
          color="primary"
          class="mt-0"
        />
        <v-checkbox
          v-model="auto_upgrade_themes"
          label="Auto Upgrade Themes"
          :disabled="loadingInstallations"
          :true-value="1"
          :false-value="0"
          color="primary"
          class="mt-0"
        />
        <p>
          This will apply to all of your WordPress installations.
        </p>
      </v-form>
      <gg-btn
        :loading="loading"
        :disabled="loadingInstallations"
        @click="save"
      >
        Save
      </gg-btn>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Queue from 'async-await-queue'
import amapi from '@/api/amapi'

export default {
  name: 'AutoupdateManage',
  data () {
    return {
      auto_upgrade_core: null,
      auto_upgrade_plugins: 0,
      auto_upgrade_themes: 0,
      loading: false,
      queue: null,
      pluginsQueue: null,
    }
  },
  computed: mapGetters({
    loadingInstallations: 'hosting_wp/loadingInstallations',
    installations: 'hosting_wp/installations',
  }),
  methods: {
    ...mapActions({
      reportError: 'reportError',
      reportSuccess: 'reportSuccess',
    }),
    async callUpgradeCore (insid) {
      const params = {
        method: `wordpress`,
        _username: this.$route.query.user,
        payload: {
          auto_upgrade_core: this.auto_upgrade_core,
          auto_upgrade_plugins: this.auto_upgrade_plugins,
          auto_upgrade_themes: this.auto_upgrade_themes,
          insid,
          save: 1
        }
      }
      try {
        const response = await amapi.softaculous_api(params)
        if (!response.done) {
          throw new Error(response.error[0] ?? 'Update error.')
        }
      } catch (e) {
        this.reportError(e)
      }
    },
    async runWpQueue () {
      this.queue = new Queue(1, 350)
      for (const inst of this.installations) {
        // eslint-disable-next-line symbol-description
        const task = Symbol()
        await this.queue.wait(task, -1)
        this.callUpgradeCore(inst.insid)
          .catch(e => {
            this.reportError(e)
            console.warn(e)
          })
          .finally(() => this.queue.end(task))
      }
      return this.queue.flush()
    },
    async save () {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }
      if (!this.installations.length) {
        this.reportSuccess('No WordPress installations found.')
        return
      }

      this.loading = true
      await this.runWpQueue()
      this.reportSuccess('New auto update settings applied.')
      this.loading = false
      this.auto_upgrade_core = null
    },
  },
}
</script>
